import { render } from "./out-hub.vue?vue&type=template&id=21522f86&scoped=true&ts=true"
import script from "./out-hub.vue?vue&type=script&lang=ts"
export * from "./out-hub.vue?vue&type=script&lang=ts"

import "./out-hub.vue?vue&type=style&index=0&id=21522f86&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21522f86"]])

export default __exports__